<template>
  <section
    class="section is-main-section no-padding-top report-summary-section enable-select-text"
  >
    <div class="level no-margin">
      <div class="level-left">
        <h3 class="level-left report-summary-section-title">Summary</h3>
        <div
          v-if="
            isUpliftAndCompareAllowed &&
              (status != 'New' || status != 'Failed' || status != 'Scheduled')
          "
          class="report-summary-apply-uplift control-level report-summary-section-compare"
        >
          <b-button
            @click="selectReportToCompare"
            type="is-primary"
            class="is-small uplift-applied"
          >
            Compare
          </b-button>
        </div>
      </div>
      <b-field
        class="level-right"
        v-if="isUpliftAndCompareAllowed && status == 'Calculated'"
      >
        <span
          class="report-summary-apply-uplift"
          v-if="localData && !localData.uplift_applied"
          >Apply Uplift</span
        >
        <b-switch
          v-if="localData && !localData.uplift_applied"
          name="apply_uplift"
          :checked="true"
          @input="showApplyUplift"
          v-model="localData.uplift_applied"
          data-cy="switch-apply-uplift"
          class="report-summary-apply-uplift"
        />
        <b-select
          name="uplift_type"
          v-model="localData.uplift_type"
          data-cy="select-uplift-type"
          v-if="localData && localData.uplift_applied"
          @input="changeApplyUplift"
          :disabled="data.uplift_type"
        >
          <!-- Set default value using :selected attribute -->
          <option
            :value="TD_WITHOUT_PD"
            :selected="
              localData &&
                (!localData.uplift_type ||
                  localData.uplift_type === TD_WITHOUT_PD)
            "
            >TD without PD</option
          >
          <option :value="PD_WITHOUT_WEIGHT">PD without Weight</option>
        </b-select>
        <div
          class="report-summary-apply-uplift"
          v-if="
            localData &&
              localData.uplift_applied &&
              localData.uplift_type === TD_WITHOUT_PD
          "
        >
          <b-input
            type="number"
            min="0"
            max="100"
            step="0.01"
            placeholder="Uplift (%)"
            name="uplift_percent"
            :value="localData.uplift_percent"
            @input="updateGlobalUpliftPercent"
            :disabled="data.uplift_type"
          />
        </div>
        <div
          class="report-summary-apply-uplift"
          style="padding-top: 4px;"
          v-if="
            localData &&
              localData.uplift_applied &&
              localData.uplift_type &&
              data.uplift_type !== PD_WITHOUT_WEIGHT
          "
        >
          <b-button
            @click="applyUpliftBtnAction"
            type="is-primary"
            class="is-small uplift-applied"
            :disabled="data.uplift_type"
          >
            Apply
          </b-button>
        </div>
        <div
          class="report-summary-apply-uplift"
          style="padding-top: 4px;"
          v-if="localData.uplift_applied"
        >
          <b-button
            @click="revertBtnAction"
            type="is-normal"
            class="is-small uplift-revert"
            v-if="data.uplift_applied"
          >
            Revert
          </b-button>
        </div>
      </b-field>
    </div>

    <div class="report-summary" data-cy="report-summary">
      <div class="report-summary-header tile is-parent">
        <h3 class="tile is-3">Reported Items</h3>

        <h3 class="tile is-2.5 is-number">
          {{
            data.reported_sum_of_units
              ? data.reported_sum_of_units
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : ""
          }}
        </h3>
        <h3 class="tile is-2.5 is-number">
          {{
            data.reported_sum_of_weight
              ? data.reported_sum_of_weight
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : ""
          }}
        </h3>
        <h3
          class="tile is-2.5"
          v-if="localData.uplift_applied && localData.uplift_type"
        ></h3>
        <h3
          class="tile is-2.5 is-number"
          v-if="
            localData.uplift_applied && localData.uplift_type === TD_WITHOUT_PD
          "
        >
          {{
            data.uplifted_reported_sum_of_units
              ? data.uplifted_reported_sum_of_units
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : ""
          }}
        </h3>
        <h3
          class="tile is-2.5 is-number"
          v-if="localData.uplift_applied && localData.uplift_type"
        >
          {{
            data.uplifted_reported_sum_of_weight
              ? data.uplifted_reported_sum_of_weight
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : ""
          }}
        </h3>
        <h3 class="tile is-2.5 is-number">
          {{
            data.sum_final_uplifted_fee
              ? data.sum_final_uplifted_fee
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " *"
              : data.final_total_fee
              ? data.final_total_fee
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " *"
              : ""
          }}
        </h3>
      </div>
      <div class="report-summary-body">
        <ul class="tile report-summary-body-title is-parent">
          <span class="tile is-3">
            Category
            <span class="additonal-info" style="padding-left: 2px;">
              <b-tooltip
                label="Please be aware that this number includes amounts of Reported Items and PD without weight Categorized"
                type="is-primary is-light"
                position="is-right"
                multilined
                data-cy="rt-additonal-info"
              >
                <i class="mdi mdi-information" />
              </b-tooltip>
            </span>
          </span>
          <span class="tile is-2.5">Total Units</span>
          <span class="tile is-2.5">Total Weights (Kg)</span>
          <span
            class="tile is-2.5"
            v-if="localData.uplift_applied && localData.uplift_type"
            >Uplift (%)</span
          >
          <span
            class="tile is-2.5"
            v-if="
              localData.uplift_applied &&
                localData.uplift_type === TD_WITHOUT_PD
            "
            >Total Uplifted Units</span
          >
          <span
            class="tile is-2.5"
            v-if="localData.uplift_applied && localData.uplift_type"
            >Total Uplifted Weights (Kg)</span
          >
          <span class="tile is-2.5 total-fee"
            >Total Fee ({{ data.currency }})</span
          >
        </ul>
        <div
          v-for="(item, index) in data.category_list"
          :key="index"
          class="report-summary-body-details"
        >
          <ul class="tile is-parent" v-if="!item.footer">
            <span class="tile is-3 report-summary-category-name">{{
              item.main_category
            }}</span>
            <span class="tile is-2.5">{{
              item.total_units
                ? item.total_units
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : 0
            }}</span>
            <span class="tile is-2.5">
              {{
                item.total_weight
                  ? item.total_weight
                      .toFixed(2)
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0
              }}
            </span>
            <span
              class="tile is-2.5"
              v-if="localData.uplift_applied && localData.uplift_type"
              ><b-input
                type="number"
                min="0"
                max="100"
                step="0.01"
                placeholder="Uplift (%)"
                :value="getItemUpliftPercent(item)"
                @input="updateItemUpliftPercent($event, item)"
                :disabled="localData.uplift_type === PD_WITHOUT_WEIGHT"
                v-if="
                  item.sub_categories.length == 0 &&
                    checkStatus &&
                    !localData.uplift_percent
                "
              />
              <span v-else>
                {{
                  getItemUpliftPercent(item) || localData.uplift_percent || 0
                }}
              </span>
            </span>
            <span
              class="tile is-2.5"
              v-if="
                localData.uplift_applied &&
                  localData.uplift_type === TD_WITHOUT_PD
              "
              >{{
                item.total_uplifted_units
                  ? item.total_uplifted_units
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0
              }}</span
            >
            <span
              class="tile is-2.5"
              v-if="localData.uplift_applied && localData.uplift_type"
              >{{
                item.total_uplifted_weight
                  ? item.total_uplifted_weight
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0
              }}</span
            >

            <span
              class="tile is-2.5 total-fee"
              v-if="!item.sum_final_uplifted_fee"
              >{{
                item.final_total_fee
                  ? item.final_total_fee
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0
              }}</span
            >
            <span
              class="tile is-2.5 total-fee"
              v-if="item.sum_final_uplifted_fee"
              >{{
                item.sum_final_uplifted_fee
                  ? item.sum_final_uplifted_fee
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0
              }}</span
            >
          </ul>

          <div v-if="item.sub_categories" class="report-summary-subCategories">
            <ul
              v-for="(subItem, subIndex) in item.sub_categories"
              :key="subIndex"
              class="tile is-parent"
            >
              <span class="tile is-3 report-summary-category-name">{{
                subItem.name
              }}</span>
              <span class="tile is-2.5">{{
                subItem.total_units
                  ? subItem.total_units
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0
              }}</span>
              <span class="tile is-2.5">{{
                subItem.total_weight
                  ? subItem.total_weight
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0
              }}</span>
              <span
                class="tile is-2.5"
                v-if="localData.uplift_applied && localData.uplift_type"
                ><b-input
                  type="number"
                  min="0"
                  max="100"
                  step="0.01"
                  placeholder="Uplift (%)"
                  v-if="!localData.uplift_percent && checkStatus"
                  :value="getSubItemUpliftPercent(subItem)"
                  @input="updateSubItemUpliftPercent($event, subItem)"
                  :disabled="localData.uplift_type === PD_WITHOUT_WEIGHT"
                />
                <span v-else>
                  {{
                    getSubItemUpliftPercent(subItem) ||
                      localData.uplift_percent ||
                      0
                  }}
                </span>
              </span>
              <span
                class="tile is-2.5"
                v-if="
                  localData.uplift_applied &&
                    localData.uplift_type === TD_WITHOUT_PD
                "
                >{{
                  subItem.total_uplifted_units
                    ? subItem.total_uplifted_units
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : 0
                }}</span
              >
              <span
                class="tile is-2.5"
                v-if="localData.uplift_applied && localData.uplift_type"
                >{{
                  subItem.total_uplifted_weight
                    ? subItem.total_uplifted_weight
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : 0
                }}</span
              >
              <span
                class="tile is-2.5 total-fee"
                v-if="!subItem.sum_final_uplifted_fee"
                >{{
                  subItem.total_uplifted_fee
                    ? subItem.total_uplifted_fee
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : 0
                }}</span
              >
              <span
                class="tile is-2.5 total-fee"
                v-if="subItem.sum_final_uplifted_fee"
                >{{
                  subItem.sum_final_uplifted_fee
                    ? subItem.sum_final_uplifted_fee
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : 0
                }}</span
              >
            </ul>
          </div>
        </div>
        <div
          v-for="(item, index) in data.category_list"
          :key="index + 'category'"
          class="report-summary-body-details"
        >
          <ul
            class="tile is-parent"
            v-if="item.footer"
            :class="{ 'is-footer': item.footer }"
          >
            <span class="tile is-3 report-summary-category-name">{{
              item.main_category
            }}</span>
            <span class="tile is-2.5"
              >{{
                item.total_units
                  ? item.total_units
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0
              }}
              <span
                v-if="
                  item.main_category ==
                    AdditionalReportingCategories.TD_WITHOUT_PD &&
                    data.td_wo_pd_percent > 0
                "
              >
                &nbsp;({{ data.td_wo_pd_percent }}%)</span
              ></span
            >
            <span class="tile is-2.5">{{
              item.total_weight
                ? item.total_weight
                    .toString()
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                : 0
            }}</span>
            <span
              class="tile is-2.5"
              v-if="localData.uplift_applied && localData.uplift_type"
            ></span>
            <span
              class="tile is-2.5"
              v-if="
                localData.uplift_applied &&
                  localData.uplift_type === TD_WITHOUT_PD
              "
              ><span class="tile is-2.5"
                >{{
                  item.total_uplifted_units
                    ? item.total_uplifted_units
                        .toString()
                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                    : 0
                }}
                <span
                  v-if="
                    item.main_category ==
                      AdditionalReportingCategories.TD_WITHOUT_PD &&
                      data.td_wo_pd_percent > 0
                  "
                >
                  &nbsp;({{ data.td_wo_pd_percent }}%)</span
                ></span
              ></span
            >
            <span
              class="tile is-2.5"
              v-if="localData.uplift_applied && localData.uplift_type"
              >{{
                item.total_uplifted_weight
                  ? item.total_uplifted_weight
                      .toString()
                      .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  : 0
              }}</span
            >
            <span class="tile is-2.5 total-fee">{{
              item.total_fee.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            }}</span>
          </ul>
        </div>
      </div>
      <div class="report-summary-header tile is-parent">
        <h3 class="tile is-3">
          Grand Total
          <span
            class="additonal-info"
            style="padding-top: 2px; padding-left: 2px;"
          >
            <b-tooltip
              label="Please be aware that this number includes amounts of Reported Items, Out of Scope, PD without weight Non-Categorized, and TD without PD"
              type="is-primary is-light"
              position="is-right"
              multilined
              data-cy="rt-additonal-info"
            >
              <i class="mdi mdi-information" />
            </b-tooltip>
          </span>
        </h3>

        <h3 class="tile is-2.5 is-number">
          {{
            data.sum_of_units
              ? data.sum_of_units
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : ""
          }}
        </h3>
        <h3 class="tile is-2.5 is-number">
          {{
            data.sum_of_weight
              ? data.sum_of_weight
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : ""
          }}
        </h3>
        <h3
          class="tile is-2.5"
          v-if="localData.uplift_applied && localData.uplift_type"
        ></h3>
        <h3
          class="tile is-2.5 is-number"
          v-if="
            localData.uplift_applied && localData.uplift_type === TD_WITHOUT_PD
          "
        >
          {{
            data.sum_uplifted_units
              ? data.sum_uplifted_units
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : ""
          }}
        </h3>
        <h3
          class="tile is-2.5 is-number"
          v-if="localData.uplift_applied && localData.uplift_type"
        >
          {{
            data.sum_uplifted_weight
              ? data.sum_uplifted_weight
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              : ""
          }}
        </h3>
        <h3 class="tile is-2.5 is-number">
          {{
            data.sum_final_uplifted_fee
              ? data.sum_final_uplifted_fee
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " *"
              : data.final_total_fee
              ? data.final_total_fee
                  .toString()
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " *"
              : ""
          }}
        </h3>
      </div>
    </div>
    <CompareModal
      :is-active="isCompareReportModal"
      :data="data"
      :summaryDataForCompare="summaryDataForCompare"
      :comparableReport="comparableReportList[0]"
      @cancel="closeModal"
      @export="exportReport"
    />
    <b-modal :active.sync="isSelectReportToCompare" has-modal-card>
      <div class="modal-card">
        <header class="modal-card-head">
          <h1 class="is-title-header modal-card-title">
            Select a report to compare
          </h1>
        </header>
        <section class="modal-card-body compare-modal-body">
          <div class="columns">
            <div class="column">
              <b-field
                v-if="
                  comparableReportDropdown &&
                    comparableReportDropdown.length > 0
                "
              >
                <multiselect
                  v-model="selectedReportToCompare"
                  :options="comparableReportDropdown"
                  :custom-label="nameWithLang"
                  placeholder="Select one"
                  label="id"
                  track-by="id"
                  :limit="5"
                  ><span
                    class="checkbox-label"
                    slot="option"
                    slot-scope="scope"
                    :title="scope.option.name"
                  >
                    {{
                      scope.option.report_tracker__period +
                        "- ( " +
                        scope.option.status +
                        " )"
                    }}
                  </span></multiselect
                >
              </b-field>
              <b-field v-else>
                <span> There is no applicable report to compare </span>
              </b-field>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot">
          <b-button
            v-if="
              comparableReportDropdown &&
                comparableReportDropdown.length > 0 &&
                selectedReportToCompare
            "
            slot="right"
            native-type="submit"
            type="is-primary"
            v-on:click="compareWithSelected"
          >
            Compare
          </b-button>
          <b-button
            slot="right"
            type="is-normal"
            @click="cancelCompareWithSelected"
          >
            Cancel
          </b-button>
        </footer>
      </div>
    </b-modal>
  </section>
</template>

<script>
// @group Report Manager Summary
import { mapGetters } from "vuex";
import { UserGroup } from "@/services/UserGroups";
import CompareModal from "@/components/ReportsManager/CompareModal.vue";
import { AdditionalReportingCategories } from "../../constants/ReportManagerConstants";
import Multiselect from "vue-multiselect";
const UPLIFT_TYPES = {
  TD_WITHOUT_PD: "TD_WITHOUT_PD",
  PD_WITHOUT_WEIGHT: "PD_WITHOUT_WEIGHT"
};
export default {
  name: "ReportManagerSummary",
  components: { CompareModal, Multiselect },
  props: {
    data: {
      type: Object
    },
    status: {
      type: String,
      default: ""
    },
    comparableReportList: {
      type: Array
    },
    comparedSummaryData: {
      type: Object
    }
  },
  data() {
    return {
      // Add your uplift types constant so it's accessible in the template
      TD_WITHOUT_PD: UPLIFT_TYPES.TD_WITHOUT_PD,
      PD_WITHOUT_WEIGHT: UPLIFT_TYPES.PD_WITHOUT_WEIGHT,
      currentUpliftFlag: true,
      isCompareReportModal: false,
      comparableReportDropdown: [],
      summaryDataForCompare: {},
      isCompareLastReport: false,
      isSelectReportToCompare: false,
      selectedReportToCompare: null,
      isFirstTimeApplying: true,
      // Local copy of data to avoid direct prop mutation
      localData: null,
      // Store uplift percentages separately to prevent re-rendering
      upliftValues: {}
    };
  },
  watch: {
    data: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (newValue) {
          // Create a deep copy of the data to avoid direct prop mutation
          this.localData = JSON.parse(JSON.stringify(newValue));
          if (
            this.localData.uplift_type === undefined ||
            this.localData.uplift_type === null
          ) {
            this.$set(
              this.localData,
              "uplift_type",
              UPLIFT_TYPES.TD_WITHOUT_PD
            );
          }
          // Initialize uplift values
          this.initializeUpliftValues();

          // Update the first time applying flag based on the data
          this.updateFirstTimeApplyingFlag();
        }
      }
    },
    "localData.uplift_type": {
      handler(newValue, oldValue) {
        // If the uplift type changes, reset the uplift percent
        if (newValue !== oldValue && this.localData) {
          // Always reset to 0 when changing uplift types
          this.localData.uplift_percent = 0;
        }
      }
    },
    comparableReportList(newValue) {
      this.comparableReportDropdown = newValue;
    },
    comparedSummaryData(newValue) {
      this.summaryDataForCompare = newValue;
    }
  },
  mounted() {
    // Initialize localData based on props
    this.$nextTick(() => {
      if (this.data) {
        // Create a deep copy of data to avoid direct prop mutation
        this.localData = JSON.parse(JSON.stringify(this.data));

        // Set default uplift_type if null or undefined
        if (
          this.localData.uplift_type === undefined ||
          this.localData.uplift_type === null
        ) {
          this.$set(this.localData, "uplift_type", UPLIFT_TYPES.TD_WITHOUT_PD);
        }

        // Initialize uplift values
        this.initializeUpliftValues();

        // Update isFirstTimeApplying flag based on current data state
        this.updateFirstTimeApplyingFlag();
      }
    });
  },
  computed: {
    ...mapGetters(["userGroups"]),
    isUpliftAndCompareAllowed() {
      if (
        this.userGroups.includes(UserGroup.EPR_ADMIN) ||
        this.userGroups.includes(UserGroup.REPORTING_RESPONSIBLE) ||
        this.userGroups.includes(UserGroup.CUSTOMER_ACCOUNT_MANAGER)
      ) {
        // if (this.data && this.data.uplift_applied) {
        //   return false;
        // } else {
        return true;
        //}
      } else {
        return false;
      }
    },
    checkStatus() {
      if (this.status != "Calculated") {
        return false;
      } else {
        return true;
      }
    },
    AdditionalReportingCategories: () => AdditionalReportingCategories
  },
  methods: {
    nameWithLang(value) {
      return `${value.report_tracker__period} — (${value.status})`;
    },
    compareWithSelected() {
      this.isSelectReportToCompare = false;
      this.loadCompareReport(this.selectedReportToCompare.id);
      this.isCompareReportModal = true;
    },
    cancelCompareWithSelected() {
      this.isSelectReportToCompare = false;
    },
    exportReport() {
      this.$emit("exportCompareReport", this.selectedReportToCompare.id);
    },
    selectReportToCompare() {
      this.loadCompareReportList();
      this.isSelectReportToCompare = true;
    },
    closeModal() {
      this.isCompareLastReport = false;
      this.isSelectReportToCompare = true;
      this.isCompareReportModal = false;
    },
    loadCompareReport(id) {
      this.$emit("loadCompareReport", id);
    },
    loadCompareReportList() {
      this.$emit("loadCompareReportList");
    },
    showApplyUplift(value) {
      this.currentUpliftFlag = value;
      // Emit event to update parent
      this.$emit("update:data", this.localData);
    },
    changeApplyUplift() {
      if (this.localData) {
        // Reset uplift percent for both types
        this.localData.uplift_percent = 0;

        // Reset all uplift values when switching uplift types
        this.upliftValues = {};

        // If we have category data, reset uplift_percent values to 0
        if (
          this.localData.category_list &&
          this.localData.category_list.length > 0
        ) {
          this.localData.category_list.forEach(item => {
            // Reset main category uplift percent
            if (item.id) {
              item.uplift_percent = 0;
              this.upliftValues[`cat_${item.id}`] = 0;
            }

            // Reset sub-categories uplift percent
            if (item.sub_categories && item.sub_categories.length > 0) {
              item.sub_categories.forEach(subItem => {
                if (subItem.id) {
                  subItem.uplift_percent = 0;
                  this.upliftValues[`subcat_${subItem.id}`] = 0;
                }
              });
            }
          });
        }

        // Update the Apply button visibility based on the selected uplift type
        if (this.localData.uplift_type === this.TD_WITHOUT_PD) {
          this.isFirstTimeApplying = true;
        } else if (this.localData.uplift_type === this.PD_WITHOUT_WEIGHT) {
          this.updateFirstTimeApplyingFlag();
        }

        // Emit event to update parent
        this.$emit("update:data", this.localData);
      }
    },

    // Helper method to update isFirstTimeApplying flag based on current data state
    updateFirstTimeApplyingFlag() {
      // Safeguard against incomplete data
      if (!this.localData) {
        return;
      }

      // If uplift is not applied, reset flag
      if (!this.localData.uplift_applied) {
        this.isFirstTimeApplying = true;
        return;
      }

      // If uplift type is TD_WITHOUT_PD, always show Apply button
      if (this.localData.uplift_type === this.TD_WITHOUT_PD) {
        this.isFirstTimeApplying = true;
        return;
      }

      // From here on, we're dealing with PD_WITHOUT_WEIGHT uplift type

      // Check if there are categories
      const hasCategories =
        this.localData.category_list && this.localData.category_list.length > 0;

      // If there are categories, always enable Apply button for PD_WITHOUT_WEIGHT
      if (hasCategories) {
        this.isFirstTimeApplying = true;
        return;
      }

      // Check for evidence of previously applied uplift
      const hasUplifted =
        (this.localData.sum_uplifted_weight &&
          this.localData.sum_uplifted_weight > 0) ||
        (this.localData.sum_final_uplifted_fee &&
          this.localData.sum_final_uplifted_fee > 0);

      // Update flag based on whether uplift has been applied before
      this.isFirstTimeApplying = !hasUplifted;
    },
    // Method to sync uplift values from our storage to the actual objects
    syncUpliftValues() {
      if (!this.localData || !this.localData.category_list) return;

      // Sync values from upliftValues back to category objects
      this.localData.category_list.forEach(item => {
        if (item.id && this.upliftValues[`cat_${item.id}`] !== undefined) {
          item.uplift_percent = this.upliftValues[`cat_${item.id}`];
        }

        // Process subcategories if any
        if (item.sub_categories && item.sub_categories.length > 0) {
          item.sub_categories.forEach(subItem => {
            if (
              subItem.id &&
              this.upliftValues[`subcat_${subItem.id}`] !== undefined
            ) {
              subItem.uplift_percent = this.upliftValues[
                `subcat_${subItem.id}`
              ];
            }
          });
        }
      });
    },

    applyUpliftBtnAction() {
      if (!this.localData) return;

      // Sync uplift values back to objects
      this.syncUpliftValues();

      // Emit event to update parent with localData
      this.$emit("upliftConfirm", this.localData);

      // If it's PD_WITHOUT_WEIGHT and there are no categories, hide the Apply button after applying
      if (this.localData.uplift_type === this.PD_WITHOUT_WEIGHT) {
        const hasCategories =
          this.localData.category_list &&
          this.localData.category_list.length > 0;

        // Only hide the Apply button if there are no categories
        // This ensures it remains visible when there are categories
        if (!hasCategories) {
          this.isFirstTimeApplying = false;
        }
      }
    },
    revertBtnAction() {
      this.$buefy.dialog.confirm({
        title: "Confirmation",
        confirmText: "Yes",
        message: "Do you want to revert applied uplift ?",
        trapFocus: true,
        onConfirm: () => {
          // Reset the local data uplift_applied flag
          if (this.localData) {
            this.localData.uplift_applied = false;
            this.localData.uplift_type = null;
            this.localData.uplift_percent = 0;

            // Reset isFirstTimeApplying flag
            this.isFirstTimeApplying = true;

            // Reset uplift values storage
            this.upliftValues = {};

            // Emit event to update parent
            this.$emit("update:data", this.localData);
          }

          // Also emit the original revert event for any backend operations
          this.$emit("revertUplift");
        }
      });
    },

    // Method to initialize uplift values storage
    initializeUpliftValues() {
      if (!this.localData || !this.localData.category_list) return;

      // Reset the storage
      this.upliftValues = {};

      // Process each category
      this.localData.category_list.forEach(item => {
        if (item.id) {
          // Store main category uplift value
          this.upliftValues[`cat_${item.id}`] = item.uplift_percent || 0;

          // Process subcategories if any
          if (item.sub_categories && item.sub_categories.length > 0) {
            item.sub_categories.forEach(subItem => {
              if (subItem.id) {
                this.upliftValues[`subcat_${subItem.id}`] =
                  subItem.uplift_percent || 0;
              }
            });
          }
        }
      });
    },

    // Debounce function to limit update frequency
    debounce(func, wait) {
      let timeout;
      return function(...args) {
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(this, args), wait);
      };
    },

    // Method to update sub-item uplift percent without causing full re-render
    updateSubItemUpliftPercent: function(value, subItem) {
      // Use a method property to ensure debounce has correct context
      if (!this._debouncedSubItemUpdate) {
        this._debouncedSubItemUpdate = this.debounce(function(value, subItem) {
          if (!subItem || !subItem.id) return;

          // Store the value in our separate storage ONLY
          // Don't modify the actual object until apply is clicked
          this.upliftValues[`subcat_${subItem.id}`] = value;
        }, 300); // 300ms debounce
      }

      this._debouncedSubItemUpdate(value, subItem);
    },

    // Method to update main item uplift percent without causing full re-render
    updateItemUpliftPercent: function(value, item) {
      // Use a method property to ensure debounce has correct context
      if (!this._debouncedItemUpdate) {
        this._debouncedItemUpdate = this.debounce(function(value, item) {
          if (!item || !item.id) return;

          // Store the value in our separate storage ONLY
          // Don't modify the actual object until apply is clicked
          this.upliftValues[`cat_${item.id}`] = value;
        }, 300); // 300ms debounce
      }

      this._debouncedItemUpdate(value, item);
    },

    // Helper method to get uplift percent value
    getItemUpliftPercent(item) {
      if (!item || !item.id) return 0;
      return this.upliftValues[`cat_${item.id}`] !== undefined
        ? this.upliftValues[`cat_${item.id}`]
        : item.uplift_percent || 0;
    },

    // Helper method to get sub-item uplift percent value
    getSubItemUpliftPercent(subItem) {
      if (!subItem || !subItem.id) return 0;
      return this.upliftValues[`subcat_${subItem.id}`] !== undefined
        ? this.upliftValues[`subcat_${subItem.id}`]
        : subItem.uplift_percent || 0;
    },

    // Method to update the global uplift percentage
    updateGlobalUpliftPercent(value) {
      if (this.localData) {
        // Store the value without triggering reactivity issues
        this.localData.uplift_percent = value;
      }
    }
  }
};
</script>
